module.exports = __webpack_public_path__ + "img/person_lizixu.3f1eeb2b.jpg";